import ethImage from "../../../assets/images/crypto/eth.png";

export const polTokens = [
  {
    image: "https://media.bananacrystal.com/images/crypto/usdt.svg",
    value: "USDT",
    name: "Tether on Polygon",
    label: "Tether POS (USDT)",
  },
  {
    image: "https://media.bananacrystal.com/images/crypto/usdc.svg",
    value: "USDC",
    name: "USD Coin on Polygon",
    label: "USD Coin (USDC)",
  },
  {
    image:
      "https://media.bananacrystal.com/wp-content/uploads/2023/07/20151846/matic.png",
    value: "POL",
    name: "Polygon",
    label: "POL (Polygon)",
  },
  {
    image:
      "https://assets.bananacrystal.com/assets/crypto/opaig-7f77beb0a435c8c644165cd58a56ada51db148d42f46d6088166618afadea70e.png",
    value: "OPAIG",
    name: "OvalPixel",
    label: "OvalPixel (OPAIG)",
  },
];

export const ethTokens = [
  {
    image: "https://media.bananacrystal.com/images/crypto/usdt.svg",
    value: "USDT",
    name: "Tether on Ethereum",
    label: "Tether (USDT)",
  },
  {
    image: ethImage,
    value: "ETH",
    name: "Ethereum",
    label: "ETH (Ethereum)",
  },
];
